export const privyAdapter = {
    isProviderInitiated: false,
    provider: null,
    supportedChains: [],
    privyContext: {
        ready: false,
        user: null,
        privyEvmWallets: [],
        privySolanaWallets: [],
        login: () => { },
        logout: async () => Promise.resolve(),
    },
    getIsProviderInitiated: () => privyAdapter.isProviderInitiated,
    setIsProviderInitiated: (isProviderInitiated) => {
        privyAdapter.isProviderInitiated = isProviderInitiated;
    },
    getPrivyContext: () => privyAdapter.privyContext,
    setPrivyContext: (context) => {
        privyAdapter.privyContext = context;
    },
    getProvider: () => privyAdapter.provider,
    setProvider: (provider) => {
        privyAdapter.provider = provider;
    },
    getSupportedChains: () => privyAdapter.supportedChains,
    setSupportedChains: (supportedChains) => {
        privyAdapter.supportedChains = supportedChains;
    },
};
